<template>
  <div class="feedbacks-wrapper">
    <div v-if="loading" class="loading-container">
      <LoadingSpinner :size="60" />
    </div>

    <div v-else-if="feedbacks.length === 0" class="empty-container">
      <h4>Sem feedbacks</h4>
    </div>

    <div v-else class="feedbacks-container">
      <div class="feedback-card" v-for="(feedback, index) in feedbacks" :key="index">
        <div class="feedback-header">
          <h5>{{ feedback.aluno.nome }}</h5>
        </div>

        <div class="feedback-body">
          <div class="rating-section">
            <div class="rating-row">
              <div class="rating-item">
                <label>Qualidade do material:</label>
                <div class="stars">
                  <IconStar 
                    v-for="i in 5" 
                    :key="`material-${i}`" 
                    :fill="i <= feedback.qualidade_material" 
                    class="star-icon" 
                  />
                </div>
              </div>
              
              <div class="rating-item">
                <label>Professor:</label>
                <div class="stars">
                  <IconStar 
                    v-for="i in 5" 
                    :key="`professor-${i}`" 
                    :fill="i <= feedback.professor" 
                    class="star-icon" 
                  />
                </div>
              </div>
            </div>

            <div class="rating-row">
              <div class="rating-item">
                <label>Áudio:</label>
                <div class="stars">
                  <IconStar 
                    v-for="i in 5" 
                    :key="`audio-${i}`" 
                    :fill="i <= feedback.audio" 
                    class="star-icon" 
                  />
                </div>
              </div>
              
              <div class="rating-item">
                <label>Vídeo:</label>
                <div class="stars">
                  <IconStar 
                    v-for="i in 5" 
                    :key="`video-${i}`" 
                    :fill="i <= feedback.video" 
                    class="star-icon" 
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="feedback-description">
            <label>Descrição:</label>
            <p>{{ feedback.descricao }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import TurmasController from '../../turmas/TurmasController'
import LoadingSpinner from 'core/LoadingSpinner'
import IconStar from 'icons/Star'

export default {
  name: 'TableFeedBack',
  components: {
    ...spinners,
    LoadingSpinner,
    IconStar
  },
  props: {
    idTurma: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      feedbacks: [],
      loading: false
    }
  },
  mounted() {
    this.loadFeedbacks()
  },
  methods: {
    loadFeedbacks() {
      this.loading = true
      
      const data = {
        turma: this.idTurma
      }
      
      TurmasController.getFeedbacks(data, (response) => {
        if (response.sucesso === true) {
          this.feedbacks = response.dados
        } else {
          this.toast(response.mensagem)
        }
        this.loading = false
      })
    },
    toast(message) {
      this.$toasted.show(message, {
        icon: 'fa-warning',
        position: 'top-right',
        duration: 3000
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.feedbacks-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.empty-container {
  text-align: center;
  padding: 2rem 0;
  color: #6c757d;
}

.feedbacks-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.feedback-card {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .feedback-header {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #eee;
    
    h5 {
      margin: 0;
      color: #1c2d5a;
      font-weight: 600;
    }
  }

  .feedback-body {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
}

.rating-section {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.rating-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  
  .rating-item {
    flex: 1;
    min-width: 120px;
    
    label {
      display: block;
      font-weight: 500;
      margin-bottom: 0.5rem;
      font-size: 0.875rem;
    }
    
    .stars {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      
      .star-icon {
        color: #ffc107;
        font-size: 1.25rem;
      }
    }
  }
}

.feedback-description {
  label {
    display: block;
    font-weight: 600;
    color: #1c2d5a;
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
  
  p {
    margin: 0;
    line-height: 1.5;
    color: #4a5568;
  }
}
</style>
